"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.ResultView = exports.ActivePanel = void 0;
var ActivePanel;
(function (ActivePanel) {
    ActivePanel[ActivePanel["NONE"] = 0] = "NONE";
    ActivePanel[ActivePanel["TOPMENU"] = 1] = "TOPMENU";
    ActivePanel[ActivePanel["CONFIG"] = 2] = "CONFIG";
    ActivePanel[ActivePanel["FAV"] = 3] = "FAV";
    ActivePanel[ActivePanel["FILTER"] = 4] = "FILTER";
    ActivePanel[ActivePanel["SORT"] = 5] = "SORT";
    ActivePanel[ActivePanel["USER"] = 6] = "USER";
    ActivePanel[ActivePanel["SAVES"] = 7] = "SAVES";
    ActivePanel[ActivePanel["LOCALIZE"] = 8] = "LOCALIZE";
})(ActivePanel = exports.ActivePanel || (exports.ActivePanel = {}));
var ResultView;
(function (ResultView) {
    ResultView[ResultView["LIST"] = 0] = "LIST";
    ResultView[ResultView["GRID"] = 1] = "GRID";
    ResultView[ResultView["MAP"] = 2] = "MAP";
})(ResultView = exports.ResultView || (exports.ResultView = {}));
var Language;
(function (Language) {
    Language[Language["NONE"] = 0] = "NONE";
    Language[Language["EN_US"] = 1] = "EN_US";
    Language[Language["ZH_HK"] = 2] = "ZH_HK";
    Language[Language["ZH_CN"] = 3] = "ZH_CN";
})(Language = exports.Language || (exports.Language = {}));
